import { Col, InputField, Label, ModalPopup, Row, ReactSelectBox } from "client/CommonComponents";
import { MaskedTextField } from "@fluentui/react"
import './DealerDetails.scss'
import { isNumber } from "utils";
import DealerVendorListContent from "client/Components/OrderManagement/Requisition/RequisitionType/DealerVendorListContent";

const DealerDetails = (props: any) => {
    const {
        reason,
        handleQuotePriceChange,
        quotePriceFormat,
        vendorDropdownList,
        onChangeVendorName,
        filterOptionVendor,
        vendor,
        dealerVendorPopupClick,
        showDealerVendorPopup,
        setShowDealerVendorPopup,
        dealerSelectOnBlur,
        vendorSearchText,
        handleChange
    } = props

    return (
        <Row>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-2 mb-3'>
                <Label required data-attribute="DealerDetails_Default_Label">Quote Price</Label>
                <InputField
                    className={reason?.quotePriceError ? 'controlValidation' : ''}
                    onChange={(value: any) => handleQuotePriceChange(value)}
                    name="quotePrice"
                    placeholder="0.00"
                    onBlur={(event: any) => quotePriceFormat(event, reason)}
                    prefix={"$"}
                    onKeyPress={(event: any) => { isNumber(event) }}
                    value={reason?.quotePrice || ''}  data-attribute="DealerDetails_quotePrice_Input" />
                {reason?.quotePriceError ? <p className='validMessage'>{reason?.quotePriceError}</p> : null}
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-2 mb-3'>
                <Label data-attribute="DealerDetails_Default_Label_2">Estimated Price (incl. tax & fees)</Label>
                <InputField
                    name="estimatedPrice"
                    placeholder="0.00"
                    prefix={"$"}
                    disabled={true}
                    value={reason?.estimatedPrice || ''}  data-attribute="DealerDetails_estimatedPrice_Input" />
            </Col>
            <p className='vendorHeading'>Dealer Details</p>
            <Row className="mx-0 px-0">
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <div className="dealer-name"><Label required data-attribute="DealerDetails_Default_Label_3">Dealer Name </Label><a href='/' className='dealer-list' onClick={dealerVendorPopupClick}>Dealer/Vendor not listed?</a></div>
                    <ReactSelectBox
                        name='dealerName'
                        options={vendorDropdownList}
                        onChange={(item: any) => onChangeVendorName(item)}
                        value={vendor || {}}
                        isSearchable={true}
                        inputValue={vendorSearchText}
                        onInputChange={(value: any, action: any) => filterOptionVendor(value, action)}
                        className={reason?.dealerNameError ? 'controlValidation' : ''}
                        onBlur={dealerSelectOnBlur}
                     data-attribute="DealerDetails_dealerName_SearchSelectBox" />
                    {reason?.dealerNameError ? <p className='validMessage'>{reason?.dealerNameError}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="DealerDetails_Default_Label_4">Dealer Contact</Label>
                    <InputField
                        name="dealerContact"
                        className={reason?.dealerContactError ? 'controlValidation' : ''}
                        placeholder='Enter Contact'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerContact}  data-attribute="DealerDetails_dealerContact_Input" />
                    {reason?.dealerContactError ? <p className='validMessage'>{reason?.dealerContactError}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="DealerDetails_Default_Label_5">Dealer Phone</Label>
                    <MaskedTextField
                        name="dealerPhone"
                        className={reason?.dealerPhoneError ? 'controlValidation form-input' : 'form-input'}
                        mask="999-999-9999"
                        placeholder='Enter Phone'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerPhone} />
                    {reason?.dealerPhoneError ? <p className='validMessage'>{reason?.dealerPhoneError}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="DealerDetails_Default_Label_6">Email Address</Label>
                    <InputField
                        name="dealerEmail"
                        className={reason?.dealerEmailError ? 'controlValidation' : ''}
                        placeholder='Enter Email'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerEmail}  data-attribute="DealerDetails_dealerEmail_Input" />
                    {reason?.dealerEmailError ? <p className='validMessage'>{reason?.dealerEmailError}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="DealerDetails_Default_Label_7">Address Line 1</Label>
                    <InputField
                        name="dealerAdd1"
                        className={reason?.dealerAdd1Error ? 'controlValidation' : ''}
                        placeholder='Enter Address Line 1'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerAdd1}  data-attribute="DealerDetails_dealerAdd1_Input" />
                    {reason?.dealerAdd1Error ? <p className='validMessage'>{reason?.dealerAdd1Error}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label data-attribute="DealerDetails_Default_Label_8">Address Line 2</Label>
                    <InputField
                        name="dealerAdd2"
                        className={reason?.dealerAdd2Error ? 'controlValidation' : ''}
                        placeholder='Enter Address Line 2'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerAdd2}  data-attribute="DealerDetails_dealerAdd2_Input" />
                    {reason?.dealerAdd2Error ? <p className='validMessage'>{reason?.dealerAdd2Error}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label data-attribute="DealerDetails_Default_Label_9">Address Line 3</Label>
                    <InputField
                        name="dealerAdd3"
                        className={reason?.dealerAdd3Error ? 'controlValidation' : ''}
                        placeholder='Enter Address Line 3'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerAdd3}  data-attribute="DealerDetails_dealerAdd3_Input" />
                    {reason?.dealerAdd3Error ? <p className='validMessage'>{reason?.dealerAdd3Error}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="DealerDetails_Default_Label_10">City</Label>
                    <InputField
                        name="dealerCity"
                        className={reason?.dealerCityError ? 'controlValidation' : ''}
                        placeholder='Enter City'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerCity}  data-attribute="DealerDetails_dealerCity_Input" />
                    {reason?.dealerCityError ? <p className='validMessage'>{reason?.dealerCityError}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="DealerDetails_Default_Label_11">State</Label>
                    <InputField
                        name="dealerState"
                        className={reason?.dealerStateError ? 'controlValidation' : ''}
                        placeholder='Enter State Code'
                        onChange={(e: any) => handleChange(e)}
                        value={reason?.dealerState}  data-attribute="DealerDetails_dealerState_Input" />
                    {reason?.dealerStateError ? <p className='validMessage'>{reason?.dealerStateError}</p> : null}
                </Col>
                <Col xs={12} sm={4} md={4} lg={4} className='mb-sm-3 mb-3'>
                    <Label required data-attribute="DealerDetails_Default_Label_12">Zip Code</Label>
                    <InputField
                        name="dealerZip"
                        className={reason?.dealerZipError ? 'controlValidation' : ''}
                        placeholder='Enter Zip Code'
                        onChange={(e: any) => handleChange(e)}
                        onKeyPress={(event: any) => { isNumber(event) }}
                        value={reason?.dealerZip}  data-attribute="DealerDetails_dealerZip_Input" />
                    {reason?.dealerZipError ? <p className='validMessage'>{reason?.dealerZipError}</p> : null}
                </Col>
            </Row>
            {
                showDealerVendorPopup &&
                <ModalPopup
                    ShowModalPopupFooter={false}
                    ModalPopupTitle="Dealer/Vendor not listed?"
                    ModalPopupType="medium"
                    closeModalPopup={() => setShowDealerVendorPopup(false)}
                    ModalPopupName='Dealer-Vendor-Popup'
                 data-attribute="DealerDetails_Default_ModalPopup">
                    <DealerVendorListContent />
                </ModalPopup>
            }
        </Row>
    )
}
export default DealerDetails;